const neg32 = (x) => -x | 0;

export default neg32;
